import {KTSVG} from '../../../_metronic/helpers'
import React, {FC, useEffect, useState, useCallback, useRef} from 'react'
import {Modal} from 'react-bootstrap'
import axios from 'axios'
import {useMemo} from 'react'
import {useAuth} from '../../../app/modules/auth'
import {useFormik} from 'formik'
import * as Yup from 'yup'
import clsx from 'clsx'
import Select from 'react-select'
import {clearLine} from 'readline'
import { useAllproductsandtypes, useUpdateproducts } from '../../contextProviders/Atomqueryprovider'
import { useSelectStyles } from '../../helpers/useSelectStyles'
type Props = {
  show: boolean
  handleClose: () => void
  sumstockrefetch: () => void
  allproductsrefetch: () => void
  variancerefetch: () => void
}


const API_URL = process.env.REACT_APP_API_URL
const CURRENCY_APP = process.env.REACT_APP_CURRENCY


const productSchema = Yup.object().shape({
  product_name: Yup.string()
  .required('A product name is required'),
  units_in_stock: Yup.number()
  .required('Stock units are required'),
  unit_buying_price: Yup.number()
  .required('Unit buying price is required'),
  unit_selling_price: Yup.number()
  .required('Unit buying price is required')
  
})


export const Addstock: React.FC<Props> = ({show, handleClose, allproductsrefetch,sumstockrefetch, variancerefetch}) => {
  const [loading, setLoading] = useState(false)
 

  const [units_in_stock, setUnits_in_stock] = useState<number>(0)
  const [unit_selling_price, setUnit_selling_price] = useState<number>(0)
  const [unit_name, setUnit_name] = useState<string>("")
  const [category_name, setCategory_name] = useState<string>("")
  const [product_unit_id, setProduct_unit_id] = useState<number>(0)
  const [unit_buying_price, setUnit_buying_price] = useState<number>(0)
  const [product_id, setProduct_id] = useState<number>(0)
  const {currentUser, logout} = useAuth()
  const addCommas = (num: any) => {
  // Handle undefined, null, or non-numeric values
  if (num === undefined || num === null || num === '') {
    return '0'
  }
  
  // Convert to number if it's a string
  const numValue = typeof num === 'string' ? parseFloat(num) : num
  
  // Check if it's a valid number
  if (isNaN(numValue)) {
    return '0'
  }
  
  return numValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

  const [newSetquantity, setNewSetquantity] = useState<any>(0)
  const [newSetprice, setNewSetprice] = useState<number>(0)


  const initialValues = {
    product_name: '',
    unit_buying_price: '0',
    unit_selling_price: '0',
    units_in_stock: '0',
    
  }
  const valuestoupdate: any = [];
 
  const {mutateAsync: updateproductsAsync} =  useUpdateproducts(valuestoupdate);

  const formik = useFormik({
    initialValues,

    validationSchema: productSchema,
    onSubmit: async (values, {setStatus, setSubmitting, resetForm}) => {

     
      setLoading(true)
   

     
      valuestoupdate.push({
        product_id: product_id,
        user_id: currentUser?.user_id,
        units_in_stock: values.units_in_stock,
        unit_buying_price: values.unit_buying_price,
        unit_selling_price: values.unit_selling_price
      })
      
 

      
      updateproductsAsync(valuestoupdate, {
        onSuccess: () =>{
          
          setLoading(false)
          setSubmitting(false)
          allproductsandtypesrefetch()
          allproductsrefetch()
          variancerefetch()
          sumstockrefetch()
          resetForm({});
          handleClose();
         
  
        },
        onError(error, variables, context) {
          setStatus('The product details are incorrect')
          setSubmitting(false)
          setLoading(false)
        },
  
      })
       
     
    },
  })


  const {
    isLoading: allproductsandtypesloading,
    isSuccess: allproductsandtypessuccess,
    data: allproductsandtypesdata,
    status: allproductsandtypesstatus,
    refetch: allproductsandtypesrefetch
  } = useAllproductsandtypes()

  
  const options = allproductsandtypesdata?.data.map((val: any, index: any) => {
    return {
      value: val.product_name,
      label: val.product_name,
      units_in_stock: val.units_in_stock,
      unit_buying_price: val.unit_buying_price,
      product_category_id: val.product_category_id,
      product_unit_id: val.product_unit_id,
      product_id: val.product_id,
      unit_selling_price: val.unit_selling_price,
      unit_name: val.unit_name,
      category_name: val.category_name
    }
  })

  return (
    <Modal
      className='modal fade'
      id='kt_modal_dashboard'
      data-backdrop='static'
      tabIndex={-1}
      role='dialog'
      show={show}
      centered
      dialogClassName='modal-lg'
      aria-hidden='true'
      onHide={handleClose}
    >
      <div className='modal-content'>
        <div className='modal-header'>
          <h3 className='fw-bolder'>Add Stock</h3>

          <div className='btn btn-icon btn-sm btn-active-light-primary ms-2' onClick={handleClose}>
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2x' />
          </div>
        </div>
        <div className='modal-body'>
          <form
            id='kt_modal_add_stock_form'
            noValidate
            className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
            onSubmit={formik.handleSubmit}
          >
            {/* begin::Input group */}
            <div className='fv-row mb-7'>
              {/* begin::Label */}
              <label className='required fw-bold fs-6 mb-2'>Select Product</label>
              {/* end::Label */}

              <Select
                options={options}
                styles={useSelectStyles()}
                isDisabled={false}
                isLoading={allproductsandtypesloading}
                isClearable={true}
                isSearchable={true}
                placeholder={"Select product ..."}
                onChange={(e: any) =>{
                

                  if (e != null) {
                    formik.setFieldValue('product_name', e.value)
                    formik.setFieldValue('unit_buying_price', e.unit_buying_price)
                    formik.setFieldValue('unit_selling_price', e.unit_selling_price)
                    setNewSetquantity(0)
                    setNewSetprice(0)
                    setUnits_in_stock(e.units_in_stock)
                    setUnit_buying_price(e.unit_buying_price)
                    setProduct_unit_id(e.product_unit_id)
                    setProduct_id(e.product_id)
                    setUnit_selling_price(e.unit_selling_price)
                    setUnit_name(e.unit_name)
                    
                    
                  }
                }
                }
              />

              {formik.touched.product_name && formik.errors.product_name && (
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block'>
                    <span role='alert'>{formik.errors.product_name}</span>
                  </div>
                </div>
              )}
            </div>
            {/* end::Input group */}

              {/* begin::Input group */}
              <label className='required fw-bold fs-6 mb-2'>Product Details</label>

            {/* end::Label */}
            <div className='row'>
              <div className='col-lg-6 fv-row mb-7'>
                <div className='border border-gray-300 border-dashed rounded py-2 px-3'>
                  <div className='d-flex align-items-center'>
                    <div className='fs-4 fw-bolder'>
                      {addCommas(units_in_stock)}{' '}
                      {unit_name}
                    </div>
                  </div>

                  <div className='fw-bold fs-7 text-gray-400'>Stock Left</div>
                </div>
              </div>

              <div className='col-lg-6 fv-row mb-7'>
                <div className='border border-gray-300 border-dashed rounded py-2 px-3'>
                  <div className='d-flex align-items-center'>
                    <div className='fs-4 fw-bolder'>
                    {product_id} 
                    </div>
                  </div>

                  <div className='fw-bold fs-7 text-gray-400'>Product ID</div>
                </div>
              </div>
            </div>

            <div className='row'>
              <div className='col-lg-6 fv-row mb-7'>
                <div className='border border-gray-300 border-dashed rounded  py-2 px-3'>
                  <div className='d-flex align-items-center'>
                    <div className='fs-4 fw-bolder'>
                      {addCommas(Number(unit_selling_price).toFixed(2))} {CURRENCY_APP}
                    </div>
                  </div>

                  <div className='fw-bold fs-7 text-gray-400'>Old Selling Price</div>
                </div>
              </div>
              <div className='col-lg-6 fv-row mb-7'>
                <div className='border border-gray-300 border-dashed rounded py-2 px-3'>
                  <div className='d-flex align-items-center'>
                    <div className='fs-4 fw-bolder'>
                      {addCommas(unit_buying_price.toFixed(2))} {CURRENCY_APP}
                    </div>
                  </div>

                  <div className='fw-bold fs-7 text-gray-400'>
                    Old Buying Price
                  </div>
                </div>
              </div>
            </div>
            {/* end::Input group */}

            {/* begin::Input group */}

            <div className='row fv-row mb-7'>
            <div className='col-xl-6'>
               {/* begin::Form group second_name */}
               <div className='fv-row mb-7'>
                  <label className='required fw-bold fs-6 mb-2'>New Selling Price</label>
                  <input
                    type='number'
                    autoComplete='off'
                  
                
                    {...formik.getFieldProps('unit_selling_price')}
                    className={clsx(
                      'form-control form-control-lg form-control-solid',
                      {
                        'is-invalid':
                          formik.touched.unit_selling_price && formik.errors.unit_selling_price,
                      },
                      {
                        'is-valid':
                          formik.touched.unit_selling_price && !formik.errors.unit_selling_price,
                      }
                    )}
                  />
                  {formik.touched.unit_selling_price && formik.errors.unit_selling_price && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{formik.errors.unit_selling_price}</span>
                      </div>
                    </div>
                  )}
                </div>
                {/* end::Form group */}
              </div>
              <div className='col-xl-6'>
               {/* begin::Form group second_name */}
               <div className='fv-row mb-7'>
                  <label className='required fw-bold fs-6 mb-2'>New Buying Price</label>
                  <input
                    type='number'
                    autoComplete='off'
                  
                
                    {...formik.getFieldProps('unit_buying_price')}
                    className={clsx(
                      'form-control form-control-lg form-control-solid',
                      {
                        'is-invalid':
                          formik.touched.unit_buying_price && formik.errors.unit_buying_price,
                      },
                      {
                        'is-valid':
                          formik.touched.unit_buying_price && !formik.errors.unit_buying_price,
                      }
                    )}
                  />
                  {formik.touched.unit_buying_price && formik.errors.unit_buying_price && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{formik.errors.unit_buying_price}</span>
                      </div>
                    </div>
                  )}
                </div>
                {/* end::Form group */}
              </div>
            </div>

            {/* end::Input group */}

            {/* begin::Input group */}

            <div className='row fv-row mb-7'>
              <div className='col-xl-6'>
                {/* begin::Form group second_name */}
                <div className='fv-row mb-7'>
                  <label className='required fw-bold fs-6 mb-2'>New Stock Units</label>
                  <input
                   
                    type='number'
                    {...formik.getFieldProps('units_in_stock')}
                    autoComplete='off'
                    className={clsx(
                      'form-control form-control-lg form-control-solid',
                      {
                        'is-invalid': formik.touched.units_in_stock && formik.errors.units_in_stock,
                      },
                      {
                        'is-valid': formik.touched.units_in_stock && !formik.errors.units_in_stock,
                      }
                    )}
                  />
                  {formik.touched.units_in_stock && formik.errors.units_in_stock && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{formik.errors.units_in_stock}</span>
                      </div>
                    </div>
                  )}
                </div>
                {/* end::Form group */}
              </div>
              
            </div>

            {/* end::Input group */}

           
           
          </form>
        </div>
        <div className='modal-footer border-0 mt-n5'>
          <button type='button' className='btn btn-light-primary' onClick={handleClose}>
            Cancel
          </button>

          <button
            type='submit'
            form='kt_modal_add_stock_form'
            className='btn btn-success'
            disabled={formik.isSubmitting || !formik.isValid || !formik.dirty}
          >
            {!loading && <span className='indicator-label'>Add Stock</span>}
            {loading && (
              <span className='indicator-progress' style={{display: 'block'}}>
                Please wait...{' '}
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            )}
          </button>
        </div>
      </div>
    </Modal>
  )
}
